import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Menu, Icon, Spin, Dropdown, Avatar } from 'antd';
import { logout } from '../../actions';
import './index.less';

class GlobalHeader extends PureComponent {
  getNameInitials = (name) => {
    const initials = name.match(/\b\w/g) || [];
    return initials.join('').toUpperCase();
  };

  handleLogoutClick = () => {
    this.props.logout();
  };

  render() {
    const { currentUser = {} } = this.props;
    const dropDownMenu = (
      <Menu className="menu">
        <Menu.Item key="logout" onClick={this.handleLogoutClick}>
          <Icon type="logout" />Logout
        </Menu.Item>
      </Menu>
    );

    return (
      <div className="header">
        <div className="right">
          {currentUser.name ? (
            <Dropdown overlay={dropDownMenu}>
              <span className="action account">
                <Avatar size="large" className="avatar">{this.getNameInitials(currentUser.name)}</Avatar>
                <span className="name">{currentUser.name}</span>
              </span>
            </Dropdown>
          ) : (
            <Spin size="small" style={{ marginLeft: 8 }} />
            )}
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logout }, dispatch);
}
export default connect(null, mapDispatchToProps)(GlobalHeader);



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/index.js